import { Moment } from 'moment';

/**
 * An enumeration of all days in a week.
 */
export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

/**
 * Returns a list of all {@link DayOfWeek} values.
 */
export function dayOfWeekValues(): DayOfWeek[] {
  return Object.values(DayOfWeek).map((dayOfWeek: Extract<typeof DayOfWeek, string>) => dayOfWeek);
}

/**
 * Converts date from {@link Moment} to {@link DayOfWeek}.
 * @param date date to be converted
 */
export function asDayOfWeek(date: Moment): DayOfWeek {
  return toDayOfWeek(date.isoWeekday());
}

/**
 * Converts iso weekday to {@link DayOfWeek}.
 * @param isoWeekday day of week (1 = Monday, 7 = Sunday).
 */
export function toDayOfWeek(isoWeekday: number): DayOfWeek {
  switch (isoWeekday) {
    case 1:
      return DayOfWeek.MONDAY;
    case 2:
      return DayOfWeek.TUESDAY;
    case 3:
      return DayOfWeek.WEDNESDAY;
    case 4:
      return DayOfWeek.THURSDAY;
    case 5:
      return DayOfWeek.FRIDAY;
    case 6:
      return DayOfWeek.SATURDAY;
    case 7:
      return DayOfWeek.SUNDAY;
    default:
      throw Error(`iso weekday ${isoWeekday} could not be parsed to day of week`);
  }
}

/**
 * Converts day of week to iso weekday (1 = Monday, 7 = Sunday).
 * @param dayOfWeek day of week to be converted.
 */
export function asIsoWeekday(dayOfWeek: DayOfWeek): number {
  return Object.keys(DayOfWeek).indexOf(dayOfWeek) + 1;
}
